import { Service } from './base';
import { request } from '../utility/services/request';
import { default as CustomFichasService } from './custom/FichasService';
import { default as CustomSolicitudService } from './custom/SolicitudService';
import { default as CustomConsultasService } from './custom/ConsultasService';
import { default as CustomConstanciasService } from './custom/ConstanciasService';
import { default as CustomConfiguracionService } from './custom/ConfiguracionService';
import ReportsService from './custom/ReportsService';
import CustomUserMicrositioService from './custom/UserMicrositioService';
// Extendemos de la clase Service para agregar nuevos métodos
class usersExtendedService extends Service {
	profile() {
		return request('GET', '/user');
	}
	modulos() {
		return request('GET', '/user/mis-modulos');
	}
	updateSelectedModulo(moduloId) {
		console.log(moduloId);
		return request('PUT', `/user/mis-modulos/${moduloId}/seleccionado`);
	}
}

class extendedFileService extends Service {
	downloadFile(id) {
		return request('GET', `/file/${id}`);
	}
	downloadFileUrl(id) {
		return `${process.env.REACT_APP_API_URL}/file/${id}`;
	}
}
const usersService = new usersExtendedService('/users', 'usuarios');
const rolesService = new Service('/roles', 'roles');
const catalogosService = new Service('/catalogs', 'catalogs');
const fichasService = new CustomFichasService('/expedient', 'fichas_activas');
const solicitudesService = new CustomSolicitudService(
	'/cancelaciones',
	'solicitud_cancelacion'
);
const fileService = new extendedFileService('/file', 'archivos');
const consultasService = new CustomConsultasService('/consulta', 'consulta');
const constanciasService = new CustomConstanciasService(
	'/constancias',
	'constancias'
);
const configSevice = new CustomConfiguracionService(
	'/configuracion',
	'configuracion'
);
const modulosService = new Service('/modulos', 'modulos');
const reportesService = new ReportsService('/reportes', 'reportes');
const userMicrositioService = new CustomUserMicrositioService('/user-micrositio', 'userMicrositio');

export {
	usersService,
	rolesService,
	catalogosService,
	fichasService,
	solicitudesService,
	fileService,
	consultasService,
	constanciasService,
	configSevice,
	modulosService,
	reportesService,
	userMicrositioService
};
